import { Service } from 'types/service';
import { CheckoutData, CheckoutForm } from './CheckoutForm';
import { HTTP } from 'utils/http';
import { useListServices } from 'hooks/useApiQueries';

interface PaymentResponse extends Record<string, unknown> {
  sca3DSecureRequired?: boolean;
  scaAuthenticationUrl?: string;
  scaTransactionId?: string;
}

export interface ServiceCheckoutProps {
  product: Service;
}

export function ServiceCheckout({ product }: ServiceCheckoutProps) {
  const { refetch: refetchServices } = useListServices();

  async function onPurchase(Payment: CheckoutData, Test?: boolean): Promise<Record<string, unknown>> {
    if (Payment.PaymentMethod === 'Alma') {
      const response = await HTTP.post('/sale/processalmapayment', { ServiceId: product.Id, Payment, Test }).send();
      return response as Record<string, unknown>;
    } else {
      const response = (await HTTP.post('/sale/services', {
        ServiceId: product.Id,
        Payment,
        Test,
      }).send()) as PaymentResponse;

      // Vérifier si une authentification SCA est requise
      if (response && response.sca3DSecureRequired) {
        // Ne pas refetch les services maintenant - ce sera fait après l'authentification
        return response as Record<string, unknown>;
      }

      // Pour les paiements réussis sans SCA, refetch les services
      await refetchServices();
      return response as Record<string, unknown>;
    }
  }

  return <CheckoutForm onPurchase={onPurchase} amount={product.Price} />;
}
